<template>
  <div id="insurance-detail">
    <div class="head">
      <div class="name-and-company">
        <div class="name" v-text="insurance.insurance_name"></div>
        <div class="company">
          本产品由<span v-text="insurance.company_name"></span>提供
        </div>
      </div>
      <div
        class="logo"
        :style="{ 'background-image': 'url(' + insurance.company_logo + ')' }"
      ></div>
      <div class="line-box"><div class="line"></div></div>
    </div>

    <div class="detail-item">
      <div class="item-title">
        <div class="left-line"></div>
        <div class="name">保障项目</div>
      </div>
      <ul class="content">
        <li
          :class="{
            'bottom-line': index + 1 !== insurance.protect_items.length,
          }"
          v-for="(item, index) in insurance.protect_items"
          :key="index"
        >
          <div class="desc" v-text="item.name"></div>
          <div class="price" v-text="item.claim"></div>
        </li>
      </ul>
    </div>

    <div class="detail-item">
      <div class="item-title">
        <div class="left-line"></div>
        <div class="name">保费明细</div>
      </div>
      <ul class="content">
        <li
          v-for="(item, index) in insurance.fee_desc"
          :key="index"
          :class="{ 'bottom-line': index + 1 !== insurance.fee_desc.length }"
        >
          <div class="desc" v-text="item.key"></div>
          <div class="price" v-text="item.value"></div>
        </li>
      </ul>
    </div>

    <div class="detail-item">
      <div class="item-title m-b-lg">
        <div class="left-line"></div>
        <div class="name">投保须知</div>
      </div>
      <div class="content-html" v-html="insurance.tips"></div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';
import InsuranceService from '../services/insuranceService.js';

export default {
  name: 'insuranceDetail',
  data() {
    return {
      case_code: utils.getParamByName('case_code'),
      visa_product_id: utils.getParamByName('visa_product_id'),
      user_order_id: +utils.getParamByName('user_order_id') || 0,
      insurance: {},
      insuranceService: new InsuranceService(this.$http),
    };
  },
  methods: {
    /**
     * 加载保险详情
     */
    getInsuranceDetail(caseCode, visaProductId) {
      if (caseCode && visaProductId) {
        this.insuranceService
          .getInsuranceDetail(caseCode, visaProductId, this.user_order_id)
          .then((data) => {
            if (data && data.body && data.body.body) {
              let tips = data.body.body.tips;

              if (tips.indexOf('\\n') > -1) {
                tips = tips.replace(/\\n/g, '');
              }

              if (tips.indexOf('\\t') > -1) {
                tips = tips.replace(/\\t/g, '');
              }
              this.insurance = data.body.body;
              this.insurance.tips = tips;
            }
          })
          .catch(() => {});
      }
    },
  },
  created() {
    utils.setTitle('保险详情');

    this.getInsuranceDetail(this.case_code, this.visa_product_id);
  },
};
</script>

<style lang="less" scoped>
#insurance-detail {
  background-color: #fff;
  padding: 0.15rem;
  box-sizing: border-box;
  .head {
    padding: 0.06rem 0 0.21rem 0;
    display: flex;
    position: relative;
    .line-box {
      width: 100%;
      box-sizing: border-box;
      .line {
        height: 1px;
        width: 100%;
        background-color: #e3e3e3;
      }
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .name-and-company {
      flex: 1;
      .name {
        font-size: 0.18rem;
        color: #444;
        line-height: 0.26rem;
      }
      .company {
        margin-top: 0.1rem;
        font-size: 0.12rem;
        color: #aaa;
      }
    }
    .logo {
      margin-left: 0.32rem;
      display: flex;
      align-content: center;
      width: 0.6rem;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 0.6rem;
      height: 0.6rem;
    }
  }
  .detail-item {
    padding: 0.25rem 0 0 0.1rem;
    .item-title {
      position: relative;
      .left-line {
        position: absolute;
        left: -0.1rem;
        top: 0;
        background-color: #ff5a60;
        border-radius: 6px;
        width: 0.03rem;
        height: 0.17rem;
      }
      .name {
        color: #444;
        font-size: 0.16rem;
        font-weight: 600;
      }
    }
    .content {
      margin-top: 0.1rem;
      li {
        padding: 0.12rem 0;
        display: flex;
        align-content: center;
        color: #6f6f6f;
        font-size: 0.14rem;
        &.bottom-line {
          border-bottom: 1px solid #f0f0f0;
        }
        .desc {
          flex: 1;
        }
        .price {
          width: 0.8rem;
          text-align: right;
        }
      }
    }
  }
}
.m-b-lg {
  margin-bottom: 0.15rem;
}
</style>

<style lang="less">
.content-html {
  font-size: 0.14rem;
  line-height: 0.22rem;
  color: #444;
  p {
    margin-top: 0.15rem;
    &:first-child {
      margin-top: 0;
    }
  }
  strong {
    font-weight: normal;
  }
}
</style>
